export type GenerateMinMaxPrice = {
    min_price: number
    max_price: number
    price: number
}

export const generateMinMaxPrice = (price: string): GenerateMinMaxPrice => {
    const cleanedString = (str: string) => str.replace(/,/g, "")

    const minPrice = price.split("-")[0]
    const maxPrice = price.split("-")[1] || price.split("-")[0]

    return {
        min_price: parseFloat(cleanedString(minPrice)),
        max_price: parseFloat(cleanedString(maxPrice)),
        price: parseFloat(cleanedString(maxPrice)),
    }
}
